/* The mobile-app pointer. No mockup exists for it — the approved specimen's screen 7 refuses and
 * stops, and this screen sends somebody somewhere instead. What it borrows from the specimen is the
 * rhythm: the shell's `.actions` top margin, the footnote's type, and the button geometry. */

.pointer {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin-top: var(--space-6);
}

/* One row per store, stacked. Two stores side by side would each be half a button wide at the
 * form column's width, and their labels ("Pobierz z Google Play") do not fit that. */
.stores {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

/* An `<a>`, styled as the ghost button — it navigates, so it must BE a link: middle-click, copy
 * link address and "open in new tab" all have to work, and a button gives none of them. The
 * declarations are duplicated from AuthButton rather than shared because the shared thing would be
 * a component, and a component cannot be an `<a>` and a `<button>` without a polymorphic `as` prop
 * that this app has exactly one use for. */
.store {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: var(--h-button);
  border-width: var(--border-hairline);
  border-style: solid;
  border-color: var(--border-2);
  border-radius: var(--r-button);
  background: var(--bg-card);
  font-family: var(--font-head);
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-heading);
  color: var(--text);
  text-decoration: none;
  transition-property: background-color, border-color;
  transition-duration: var(--dur-fast);
  transition-timing-function: var(--ease);
}

.store:hover {
  background: var(--bg-inset);
}

.store:focus-visible {
  outline: var(--border-thick) solid var(--accent);
  outline-offset: var(--space-1);
}

/* The quieter line under the action — "are you a trainer and seeing this?". `--text-2`, never
 * `--text-3`: the tertiary ink measures 2.17–2.80 on light surfaces and fails AA, and this line has
 * to be readable by the one visitor it is for. */
.hint {
  margin: var(--space-0);
  font-family: var(--font-body);
  font-size: var(--fs-small);
  font-weight: var(--fw-medium);
  line-height: var(--lh-relaxed);
  color: var(--text-2);
}
